import { createSessionStore } from 'stencil-store-storage';

const { state } = createSessionStore('exit-intent', {});

export default state;
